module.exports = __webpack_public_path__ + "img/wangzhe_p.849dd81d.png";